import { useState, useEffect } from "react";
import Snow from "./Snow";
import { useDispatch, useSelector } from 'react-redux';
import RequisitionAction from '../../../../../../../Store/Component/Requisition/RequisitionAction'

const SnowContainer = (props:any) => {
  const managedEquipRef = props?.managedEquipRef
  const dispatch = useDispatch()
     
  const [manufacturerDropDownList, setManufacturerDropDownList] = useState<any>([]);
  const [SizeDropDownList, setSizeDropDownList] = useState<any>([]);
  const [TypeDropDownList, setTypeDropDownList] = useState<any>([]);
  const [categoryDropdownList, setCategoryDropdownList] = useState<any>([]);

  const { managedEquipmentDropDown, managedEquipmentValues, editRequestDetails, isEditRequestClick}: any = useSelector((state? : any) => ({
    managedEquipmentDropDown: state.ManagedEquipmentDropDownReducer.managedEquipmentDropDown,
    managedEquipmentValues: state.RequisitionReducer.managedEquipmentValues,
    editRequestDetails: state.RequisitionReducer.editRequestDetails,
    isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
  }));

  ///Modified dropDown values as required
  useEffect(()=>{
    if (managedEquipmentDropDown?.length > 0) {
      managedEquipmentDropDown?.map((item: any) => {
        if (item?.dropdownName == "Manufacturer") {
          const defaultManufacturerOption = {
            text: "Select Manufacturer",
            value: null
        };
        item?.dropdownList?.unshift(defaultManufacturerOption);
          let manufacturerDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setManufacturerDropDownList(manufacturerDropdownListTemp)
        } else if (item?.dropdownName == "Category") {
          const defaultCategoryOption = {
            text: "Select Category",
            value: null
        };
        item?.dropdownList?.unshift(defaultCategoryOption);
        let categoryDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setCategoryDropdownList(categoryDropdownListTemp)
        }else if (item?.dropdownName == "Size") {
          const defaultSizeOption = {
            text: "Select Size",
            value: null
        };
        item?.dropdownList?.unshift(defaultSizeOption);
        let sizeDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setSizeDropDownList(sizeDropdownListTemp)
        }else if (item?.dropdownName == "Type") {
          const defaultTypeOption = {
            text: "Select Type",
            value: null
        };
        item?.dropdownList?.unshift(defaultTypeOption);
        let typeDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setTypeDropDownList(typeDropdownListTemp)
        }
      })
    }
  },[managedEquipmentDropDown])

  useEffect(()=> {
    if (isEditRequestClick) {
      let managedEquipmentValuesTemp: any = {}
      let selectedManufacturer: any = ""
      let selectedCategory: any = ""
      let selectedSize: any = ""
      let selectedType: any = ""
      
      if (editRequestDetails?.manufacturer && manufacturerDropDownList?.length > 0) {
        selectedManufacturer = manufacturerDropDownList?.find((option: any) => option?.value === editRequestDetails?.manufacturer)
      }

      if (editRequestDetails?.category && categoryDropdownList?.length > 0) {
        selectedCategory = categoryDropdownList?.find((option: any) => option?.value === editRequestDetails?.category)
      }

      if (editRequestDetails?.size && SizeDropDownList?.length > 0) {
        selectedSize = SizeDropDownList?.find((option: any) => option?.value === editRequestDetails?.size)
      }

      if (editRequestDetails?.type && TypeDropDownList?.length > 0) {
        selectedType = TypeDropDownList?.find((option: any) => option?.value === editRequestDetails?.type)
      }

      managedEquipmentValuesTemp = { 
        ...managedEquipmentValues, 
        manufacturer: selectedManufacturer, 
        category: selectedCategory,
        size: selectedSize,
        type: selectedType
      }
      dispatch(RequisitionAction.setManagedEquipmentValues(managedEquipmentValuesTemp))
    }
  }, [isEditRequestClick, manufacturerDropDownList, SizeDropDownList, TypeDropDownList, categoryDropdownList])

useEffect(()=> {
  props.managedEquipRef.current[1]?.focus()
},[])

const handleManufacturerChange = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item.label !== 'Select Manufacturer') {
    props.managedEquipRef.current[2]?.focus()
  }
}
const handleCategoryChange = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item.label !== 'Select Category') {
    props.managedEquipRef.current[3]?.focus()
  }

}
const handleSizeChange = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item.label !== 'Select Size') {
    props.managedEquipRef.current[4]?.focus()
  }
}
const handleTypeChange = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item.label !== 'Select Type') {
    props.managedEquipRef.current[5]?.focus()
  }
}

return (
    <Snow
      managedEquipmentValues={managedEquipmentValues}
      categoryDropdownList={categoryDropdownList}
      manufacturerDropDownList={manufacturerDropDownList}
      SizeDropDownList={SizeDropDownList}
      TypeDropDownList={TypeDropDownList}
      managedEquipRef={managedEquipRef}
      handleManufacturerChange={handleManufacturerChange}
      handleCategoryChange={handleCategoryChange}
      handleSizeChange={handleSizeChange}
      handleTypeChange={handleTypeChange}
    />
  )
}

export default SnowContainer;
